__webpack_require__.p = "/assets/turbo/db7d3c01/quellede/_next/";